// Minimal RFC-4180-style CSV serialization. No external dependency — the
// export volume this codebase deals with (HR case lists, dashboard summary
// numbers) doesn't warrant one. Lives in `shared` because both the API
// (Workers runtime, case-list export) and the web app (browser, dashboard
// report export) need identical field-escaping behaviour.

// Prepend to a CSV body so Excel on Windows correctly detects UTF-8 when the
// file is opened directly (double-click) rather than imported — without it,
// non-ASCII characters (e.g. accented names) render as mojibake.
export const CSV_BOM = '\uFEFF';

// A value starting with one of these characters is interpreted as a formula
// by Excel/Sheets/LibreOffice when the cell is opened. Prefixing with a
// single quote forces text interpretation without changing what's displayed
// — the standard mitigation for CSV/formula injection via untrusted fields.
const FORMULA_TRIGGER = /^[=+\-@\t\r]/;

export function csvField(value: string | number | boolean | null | undefined): string {
  let s = value === null || value === undefined ? '' : String(value);
  if (FORMULA_TRIGGER.test(s)) s = `'${s}`;
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function csvRow(fields: Array<string | number | boolean | null | undefined>): string {
  return fields.map(csvField).join(',');
}
